
export const Paths = {
    HOME: "/",
    ABOUT: "/about",
    MEETINGS: "/meetings",
    MORE_INFO: "/about/the-meeting",
    REGISTER: "/register",
    USER: "/user",
}

export const Links = {
    INSTAGRAM: "https://www.instagram.com/colrt13",
    FACEBOOK: "https://www.facebook.com/groups/9577665305",
}